import { render, staticRenderFns } from "./Couple.vue?vue&type=template&id=746a661e&scoped=true&"
import script from "./Couple.vue?vue&type=script&lang=js&"
export * from "./Couple.vue?vue&type=script&lang=js&"
import style0 from "./Couple.vue?vue&type=style&index=0&id=746a661e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746a661e",
  null
  
)

export default component.exports